










































































import { Component, Vue } from 'vue-property-decorator'
import { HistoricoDeEmissaoDeEtiqueta } from '@/models/EstacaoDeImpressao'

export const HISTORICO_DE_EMISSAO_DE_ETIQUETA_KEY = 'HISTORICO_DE_EMISSAO_DE_ETIQUETA'
const MAX_HISTORICO = 10

@Component
export default class DialogoDeHistoricoDeEmissaoDeEtiqueta extends Vue {
	aberto = false
	historico: HistoricoDeEmissaoDeEtiqueta[] = []
	reimprimindoId: string | null = null

	mostrar() {
		this.carregarHistorico()
		this.aberto = true
	}

	carregarHistorico() {
		try {
			this.historico = JSON.parse(localStorage.getItem(HISTORICO_DE_EMISSAO_DE_ETIQUETA_KEY) || '[]')
		} catch {
			this.historico = []
		}
	}

	static salvar(item: HistoricoDeEmissaoDeEtiqueta) {
		try {
			const historico: HistoricoDeEmissaoDeEtiqueta[] = JSON.parse(
				localStorage.getItem(HISTORICO_DE_EMISSAO_DE_ETIQUETA_KEY) || '[]',
			)
			historico.unshift(item)
			if (historico.length > MAX_HISTORICO) {
				historico.length = MAX_HISTORICO
			}
			localStorage.setItem(HISTORICO_DE_EMISSAO_DE_ETIQUETA_KEY, JSON.stringify(historico))
		} catch { /* silently fail */ }
	}

	reimprimir(item: HistoricoDeEmissaoDeEtiqueta) {
		this.reimprimindoId = item.id
		this.$emit('reimprimir', item)
	}

	setCarregando(id: string | null) {
		this.reimprimindoId = id
	}

	limparHistorico() {
		localStorage.removeItem(HISTORICO_DE_EMISSAO_DE_ETIQUETA_KEY)
		this.historico = []
	}

	totalDeEtiquetas(item: HistoricoDeEmissaoDeEtiqueta): number {
		return item.itens.reduce((total, produto) => total + (Number(produto.quantidade) || 0), 0)
	}

	formatarDataHora(iso: string): string {
		return new Date(iso).toLocaleString('pt-BR')
	}
}
